import captchaConfig from 'configs/captcha'
import type { CaptchaSettings } from 'helpers/captcha/contracts'

export function getCaptchaSettings(
  proactiveEnabled: boolean,
): CaptchaSettings {
  const siteKey = captchaConfig.turnstileSiteKey
  return {
    // Without a site key there is nothing to solve proactively, so fall back
    // to reactive solving (plain request, solve on CAPTCHA_REQUIRED).
    proactiveEnabled: proactiveEnabled && siteKey !== '',
    siteKey,
  }
}
